import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getRangeFromToLabel } from '@/bundles/GroupFilters/helpers/formatters/range/getRangeFromToLabel';
import { Nullable } from '@/utils/types';
import { filterDateRangeLabels, FilterDateRangeTypeEnum } from '@/bundles/GroupFilters/consts';
import { formatDateIsoLuxon } from '@/utils/filters';

export type DateRangeValueType = [Nullable<string>, Nullable<string>];
export type PresetOrRangeValueType = DateRangeValueType | [FilterDateRangeTypeEnum];
export type PresetDateType = FilterDateRangeTypeEnum.LAST_7_DAYS | FilterDateRangeTypeEnum.LAST_12_MONTHS | FilterDateRangeTypeEnum.THIS_CALENDAR_YEAR;

export const PRESET_DATE_TYPES: PresetDateType[] = [
  FilterDateRangeTypeEnum.LAST_7_DAYS,
  FilterDateRangeTypeEnum.LAST_12_MONTHS,
  FilterDateRangeTypeEnum.THIS_CALENDAR_YEAR,
];

export function isPresetDateType (value: unknown): value is PresetDateType {
  return PRESET_DATE_TYPES.includes(value as PresetDateType);
}

export function getDateRangeFormattedValue (value: PresetOrRangeValueType): string {
  if (isPresetDateType(value?.[0])) {
    const presetType = value[0];
    return filterDateRangeLabels[presetType] ?? '';
  }

  const hasAnyDate = value.some(isValuePresent);
  if (!hasAnyDate) {
    return '';
  }

  const formattedDates = value.map(formatDateIsoLuxon);
  return getRangeFromToLabel(formattedDates);
}
